import supportedChains from '@/utils/chains';

export const getStaticPaths = () => ({
  paths: supportedChains.map(chain => ({
    params: {
      chain: chain.routePrefix,
    },
  })),
  fallback: false,
});

export { default, getStaticProps } from '../index';
